<template>
  <div :id="id" :class="wrapperClasses">
    <div class="mx-auto w-full max-w-screen-2xl px-5 md:px-12">
      <component :is="heading" v-if="title" :class="headingClass" class="font-bold">{{ title }}</component>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  heading?: string;
  title?: string;
  subtitle?: string;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.textColor ? props.textColor : "text-[color:var(--color-body-text)",
    "py-4 lg:py-8",
  ];
});

const headingClass = computed(() => {
  return props.heading === "h1"
    ? "text-3xl lg:text-4xl"
    : props.heading === "h2"
      ? "text-2xl lg:text-3xl"
      : props.heading === "h3"
        ? "text-xl lg:text-2xl"
        : props.heading === "h4"
          ? "text-lg lg:text-xl"
          : "text-lg";
});
</script>

<style lang="scss">
.title-block {
  &.bg-neutral-800 {
    color: white;
  }
}
</style>
